import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth.jsx";
import { Toaster } from "sonner";
import LandingLayout from "./components/LandingLayout.jsx";
import Landing from "./pages/Landing.jsx";
import HorseProfile from "./pages/HorseProfile.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import AdminDashboard from "./pages/AdminDashboard.jsx";
import AdminSubmissions from "./pages/AdminSubmissions.jsx";
import AdminComments from "./pages/AdminComments.jsx";
import HorseForm from "./pages/HorseForm.jsx";
import ForSale from "./pages/ForSale.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingLayout><Landing /></LandingLayout>} />
          <Route path="/sale" element={<LandingLayout><ForSale /></LandingLayout>} />
          <Route path="/horse/:id" element={<LandingLayout><HorseProfile /></LandingLayout>} />
          <Route path="/admin/login" element={<LandingLayout><AdminLogin /></LandingLayout>} />
          <Route path="/admin" element={<ProtectedRoute><LandingLayout><AdminDashboard /></LandingLayout></ProtectedRoute>} />
          <Route path="/admin/new" element={<ProtectedRoute><LandingLayout><HorseForm /></LandingLayout></ProtectedRoute>} />
          <Route path="/admin/edit/:id" element={<ProtectedRoute><LandingLayout><HorseForm /></LandingLayout></ProtectedRoute>} />
          <Route path="/admin/submissions" element={<ProtectedRoute><LandingLayout><AdminSubmissions /></LandingLayout></ProtectedRoute>} />
          <Route path="/admin/comments" element={<ProtectedRoute><LandingLayout><AdminComments /></LandingLayout></ProtectedRoute>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
